<template>
  <div class="app">
    <allPage :i18n="i18n" class="candidate_tanpin">
      <div>
        <div
          v-if="$store.state.loadingShow"
          style="
            position: fixed;
            transform: translate(-50%, -50%);
            left: 50%;
            top: 50%;
          "
        >
          <img v-filter-http src="@/assets/images/loading.gif" alt="loading" />
        </div>
        <div v-show="!$store.state.loadingShow" class="page">
          <div class="a-header">
            <v-header v-if="!$store.state.whichHeader"></v-header>
            <m-header v-if="$store.state.whichHeader"></m-header>
          </div>
          <div class="a-content">
            <router-view></router-view>
          </div>
          <v-footer></v-footer>
        </div>
        <EFFeedBack @postFeedback="postFeedback"></EFFeedBack>
      </div>
    </allPage>
  </div>
</template>

<script>
import oc_v1_api from "@/mixins/oc_v1_api";
import { Footer } from "site-footer";
import "site-footer/dist/site-footer.css";
export default {
  mixins: [oc_v1_api],
  provide() {
    //提供
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true,

      ifScale: true,
      i18n: [],
      ifShowByEdu: true,
      // 低学历:
      lowEducation: [
        "JuniorHighSchool",
        "SeniorHighSchool",
        "TechnicalSchool",
        "SpecialSchool",
      ],
      shownew: false,
    };
  },
  created: async function () {
    await this.getRegistProgresss();
    this.i18n = require("../../data/code.json");
    this.$store.state.loadingShow = false;
  },
  watch: {
    $route(to, from) {
      if (to.name == "Agreement") {
        this.shownew = true;
      } else {
        this.shownew = false;
      }
      //不要缩放
      if (to.name == "resume") {
        this.startScalejs("html", true);
      } else {
        this.startScalejs("html");
      }
    },
  },
  beforeDestroy: function () {},
  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
    nextIp() {
      this.ip = [this.ip[0] + 0.1, this.ip[1] + 0.1];
    },
    //获取注册进展
    async getRegistProgresss() {
      let page = await this.getRegistProgress().then((res) => {
        if (res.status == "200" && res.data != 3) {
          this.$store.state.whichHeader = true;
          if (this.shownew) {
            return "Agreement";
          } else {
            return "basicCard";
          }
        } else {
          this.$store.state.whichHeader = false;
        }
      });

      this.gotopath(page);
    },
    gotopath(page) {
      if (page) {
        this.$router.push({
          name: page,
        });
      }
    },
    postFeedback(data) {
      if (data) {
        this.Allmodel("意见反馈提交成功", "消息提示", 1);
      } else {
        this.Allmodel("意见反馈提交失败,请稍后重试", "消息提示", 2);
      }
    },
    ifLowEdu(name) {
      if ($.inArray(name, this.lowEducation) != -1) {
        this.ifShowByEdu = false;
      } else {
        this.ifShowByEdu = true;
      }
    },
  },
  components: {
    "v-header": (resolve) => require(["@/components/header/index"], resolve),
    "m-header": (resolve) => require(["@/components/newheader"], resolve),
    "v-footer": Footer,
    EFmodelMes: (resolve) => require(["@/components/modelMes"], resolve),
  },
};
</script>
<style scoped>
.page {
  display: flex;
  width: 100%;
  flex-direction: column;
}

.a-header {
  height: 90px;
}

.a-content {
  min-height: 750px;
  background: #fbfbfb;
}
</style>
